export default __webpack_public_path__ + "static/media/59t.2f09ac77.jpg";